// Vendors
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useErrorBoundary } from 'react-error-boundary';
// Contexts
import { useLayoutContextConsumerHook } from 'components/layout/contexts/layout.context';
import { useUploadIdContextConsumerHook } from 'containers/upload-id/contexts/upload-id.context';
import { useAppContextConsumerHook } from 'contexts/app.context';
// Event Handlers
import { UploadIdDifferentDataHandlers } from '../handlers/upload-id-different-data.handlers';
import { UploadIdDifferentDataTrackingHandlers } from '../handlers/upload-id-different-data.tracking.handlers';
// Hooks
import { useAppTrackingHook } from 'tracking/app-tracking.hook';
// Types
import { UploadIdDifferentDataCustomerApiResponseType } from '../types/upload-id-different-data-customer-api-response.type';
import { UploadIdDifferentDataHookType } from './types/upload-id-different-data.hook.type';

const useDifferentDataUploadIdLandingHook = (): UploadIdDifferentDataHookType => {
  const [customerData, setCustomerData] = useState<UploadIdDifferentDataCustomerApiResponseType>(
    {}
  );
  const [fetching, setFetching] = useState<boolean>(true);

  const { formatMessage, formatDate } = useIntl();

  const { handleContinueButtonClickTracking, handleUploadAgainButtonClickTracking } =
    useAppTrackingHook(UploadIdDifferentDataTrackingHandlers);

  const { showBoundary: setError } = useErrorBoundary();

  const { setCurrentState } = useAppContextConsumerHook(),
    { verificationInformation } = useUploadIdContextConsumerHook(),
    { flowApiData, setMainButtonConfiguration } = useLayoutContextConsumerHook(),
    { validationId: initialValidationId = '' } = flowApiData || {}, // Puede venir del details inicial si ha entrado de nuevo
    { validationId = '' } = verificationInformation || {}; // Puede estar vivo en session

  const { handleFetchOCRCustomerDataEvent, handleUploadAgainDocumentsLinkClick } =
    UploadIdDifferentDataHandlers({
      formatMessage,
      initialValidationId,
      setCurrentState,
      setCustomerData,
      setFetching,
      setError,
      setMainButtonConfiguration,
      validationId,
      handleContinueButtonClickTracking,
      handleUploadAgainButtonClickTracking,
    });

  useEffect(() => {
    handleFetchOCRCustomerDataEvent();
  }, []);

  return {
    fetching,
    formatMessage,
    formatDate,
    customerData,
    handleUploadAgainDocumentsLinkClick,
  };
};

export { useDifferentDataUploadIdLandingHook };
